<template>
  <detail-row-wrapper :save-function="submit" :cancel-function="cancel">

    <div class="contents-wrapper">

      <div class="main-contents">

        <detail-row-component title="공급자 이름" :inner-vertical="true">

          <layout-input v-model="editable.name"
                        :regex="regex(1, 100).ko_en_num"
                        placeHolder="한글 이름을 입력해주세요."/>

        </detail-row-component>

        <detail-row-component title="공급 준비 일자" :inner-vertical="true">

          <layout-input v-model="editable.prepareDays"
                        :regex="regex(1, 100).num"
                        placeHolder="공급 준비 일자를 입력해주세요."/>

        </detail-row-component>
      </div>
    </div>
  </detail-row-wrapper>
</template>

<script>
import { validate, multipleValidate, regex } from '@/utils/utils';
import DetailRowWrapper from '@/spa/components/detail-row/DetailRowWrapper';
import DetailRowComponent from '@/spa/components/detail-row/DetailRowComponent';
import LayoutInput from '@/spa/components/LayoutInput';

export default {
  name: 'SupplierEditor',
  components: {
    LayoutInput,
    DetailRowWrapper,
    DetailRowComponent,
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    regex(min, max) {
      return regex(min, max);
    },
    async submit() {
      this.editable.id = this.rowData.id;
      const validateResult = multipleValidate([
        validate({ message: '공급자 이름', target: this.editable.name, regex: this.regex(1, 100).ko_en_num }),
        validate({ message: '공급 준비 일자', target: this.editable.prepareDays, regex: this.regex(1, 100).num }),
      ]);
      if (this.editable.isChecked && validateResult.flag) {
        this.$toast(validateResult.message);
        return;
      }
      const result = await this.$store.dispatch('updateSupplier', this.editable);
      if (result.response) {
        this.$table.updateField();
      }
      this.$toast(result.message);
    },
    cancel() {
      this.$table.updateField();
    },
  },
  data() {
    return {
      editable: {
        name: this.rowData.name,
        prepareDays: this.rowData.prepare_days,
        isChecked: this.rowData.is_checked,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.contents-wrapper {
  position: relative;
  min-height: 200px;
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
  .main-contents {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/supplier-management/detail-row/SupplierEditor.vue